<template>
  <section class="all-notice">
    <div class="all-notice-header clearfix">
      <h4 class="title fl">提到我的</h4>
      <span class="unread read-count fl">未读（{{ unread }}）</span>
      <span class="read read-count fl">已读（{{ read }}）</span>
      <a href="javascript:;" class="notice-btn fr" @click="markAllRead" v-if="list.length > 0">全部标记为已读</a>
    </div>
    <div class="all-notice-body">
      <ul class="all-notice-list" v-if="list.length > 0">
        <li v-for="(item, $index) in list" @click="markRead($index)" :class="{'unread': !item.status}">
          <div class="notice-item clearfix">
            <p class="notice-title fl" :class="{'unread-item': item.status == 0}">
              <span v-html="item.title"></span>
              <a href="javascript:;" class="show-detail" @click="showDetail($index)" v-if="item.addition.length">{{ item.detailBtn.text }}详情<i class="fa" :class="'fa-angle-' + (item.detailBtn.icon == 'up' ? 'up' : 'down')"></i></a>
            </p>
            <p class="notice-time fr">{{ item.elapsed }}</p>
          </div>
          <div class="detail" :class="{collapsed: !item.expanded}" v-if="item.addition.length" >
            <p v-for="row in item.addition" v-html="row">
            </p>
          </div>
        </li>
      </ul>
      <div class="all-notice-empty" v-else>
        <img src="../../../images/personal_center/work-null.png" alt="">
        <p>暂无消息通知</p>
      </div>
    </div>
    <div class="all-notice-footer" v-if="showLoadMore">
      <div class="btns">
        <a href="javascript:;" class="notice-btn" @click="loadMore()">加载更多</a>
      </div>
    </div>
  </section>
</template>

<script type="text/javascript">
  export default {
    data() {
      return {
        read: 0,          //已读数量
        unread: 0,        //未读数量
        total: 0,         //消息总数量
        list: [],          //消息列表
        showLoadMore: true,
        curPage: 0
      }
    },
    methods: {
      /*
       ** 初始化页面，获取内容
       */
      init() {
        this.loadMore();
      },
      /*
       ** 显示详情
       */
      showDetail(index) {
        let item = this.list[index],
            detail = item.detailBtn;

        item.expanded = !item.expanded;
        detail.text = item.expanded ? '收起' : '展开';
        detail.icon = item.expanded ? 'up' : 'down';
      },
      /*
       ** 标记已读
       */
      markRead(index) {
        let item = this.list[index];

        if(!item.status){   //该项未读
          axios.post(myUrl + 'feed/news/read/' + item.id + '/').then(response => {
            let res = response.data;

            if(res.code == 0 && res.result){
              item.status = 1;
              this.read++;
              this.unread--;
            }
            else{
              console.log(res.message);
            }
          }, reject => {
            console.log(reject);
          })
        }
      },
      /*
       ** 标记全部已读
       */
      markAllRead() {
        axios.post(myUrl + 'feed/news/read/').then(response => {
          let res = response.data;

          if(res.code == 0 && res.result){
            let list = this.list;

            for(let item of list){
              item.status = 1;
            }

            this.read = this.total;
            this.unread = 0;
          }
          else{
            console.log(res.message);
          }
        }, reject => {
          console.log(reject);
        });
      },
      /*
       ** 加载更多
       */
      loadMore() {
        let page = ++this.curPage;
        axios.post(myUrl + 'feed/news/at_me/', qs.stringify({page: page})).then(response => {
          let res = response.data;

          if(res.code == 0 && res.result){
            let data = res.data;

            this.read = data.read;
            this.unread = data.unread;
            this.total = data.total;

            for(let item of data.items){
              item.expanded = false;
              item.detailBtn = {
                text: '展开',
                icon: 'down'
              };
            }

            for(let item of data.items){
              this.list.push(item);
            }
            if(data.page.curPage >= data.page.totalPage){
              this.showLoadMore = false;
            }
          }
          else{
            console.log(res.message);
          }
        }, reject => {
          console.log(reject);
        });
      }
    },
    mounted() {
      this.init();
    }
  }
</script>

<style media="screen" lang="scss" scoped>
  $border_color: #f4f4f4;
  $basic_color: #aaa;
  $active_color: #57a3f1;

  .all-notice{
    padding: 30px 45px;
    &-header{
      padding-bottom: 14px;
      margin-bottom: 16px;
      border-bottom: 1px solid $border_color;
    }
    &-footer{
      margin-top: 40px;
      text-align: center;
    }
    &-list{
      li{
        padding: 13px 0;
        border-bottom: 1px solid $border_color;
      }
      .notice-item{
        position: relative;
        padding-left: 12px;
        color: #888;
        font-size: 12px;
        &:before{
          content: '';
          position: absolute;
          top: 50%;
          left: 0;
          transform: translateY(-50%);
          width: 4px;
          height: 4px;
          border-radius: 50%;
          background-color: $basic_color;
        }
        .unread-item{
          font-weight: bold;
        }
        .notice-time{
          color: #adadb2;
        }
        a{
          margin: 0 7px;
          color: $active_color;
          &.show-detail{
            i{
              margin-left: 5px;
            }
          }
        }
      }
    }
    &-empty{
      padding: 120px 0;
      text-align: center;
      img{
        margin-bottom: 25px;
      }
      p{
        font-size: 16px;
        color: #878996;
      }
    }
    .title{
      margin-right: 13px;
      line-height: 27px;
      color: #77787f;
      font: {
        size: 18px;
        weight: bold;
      }
    }
    .read-count{
      font-size: 14px;
      cursor: default;
      line-height: 27px;
      &.unread{
        padding-right: 10px;
        margin-right: 10px;
        border-right: 1px solid $border_color;
        color: $active_color;
      }
      &.read{
        color: $basic_color;
      }
    }
    .detail{
      max-height: 10000px;
      opacity: 1;
      padding: 5px 0 0 12px;
      font-size: 12px;
      color: $basic_color;
      transition: all linear .3s;
      overflow: hidden;
      &.collapsed{
        max-height: 0;
        opacity: 0;
      }
      & > p{
        padding-top: 15px;
      }
    }
    .notice-btn{
      padding: 4px 15px;
      border: 1px solid #ddd;
      border-radius: 2px;
      font-size: 12px;
      color: #a6a6a6;
      transition: none;
      &:hover{
        background-color: $border_color;
      }
    }
    .notice-title{
      width: 90%;
    }
    li.unread{
      cursor: pointer;
    }
  }
</style>



// WEBPACK FOOTER //
// at_me.vue?d391a228